import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import { Autocomplete, Box, TextField } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllFacilities,
  getAllMeterTags,
  getAllMeterStatus,
  getAllProject,
  getClientLocations,
  getAllAssignees,
  getJoinedGreenUsers,
  getAllFacilitiesForTickets,
  getAllTicketStatus,
  getAllFacilityStatus,
  getAllClientAssetCategories,
  getAllMaintenanceEngineers,
  getAllMaintenanceApprovers,
  getAllMaintenanceLogStatus,
  getAllComponentsCategories,
  getAllClientsForFilter
} from "../../Redux/actions";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Chip from "@mui/material/Chip";
import { Grid, Typography } from "@mui/material";
import { filter } from "lodash";
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { PROJECT_TYPE_VALUES } from "../../utils";
import { inputLabelFocusedStyle, selectFocusedStyle } from "../../theme/formStyles";

const Filter = (props) => {
  const dispatch = useDispatch();
  let { client_id: client_id } = useParams();

  const {
    segmentDataOption,
    showFilterDialog,
    setShowFilterDialog,
    sectionListOption,
    reportTypesOption,
    plantTypeOption,
    capacityOption,
    parameterGrpOption,
    alertOption,
    regionsOption,
    updateQueryParams,
    setIsSearchOrFilterApplied,
    queryParams,
    filterArea,
    clearFilters,
    handleTabSwitch,
    checkForUrlFacility,
    checkForMyTickets,
    isBrowserBackAction,
    bdFilterOptions,
    pmFilterOptions
  } = props;

  const allFilters = [
    "region",
    "location_id",
    "segment",
    "section",
    "type",
    "facility_id",
    "plantType",
    "capacity",
    "project_id",
    "meterTags",
    "meterGrp",
    "alert",
    "meterStatus",
    "assignee",
    "status",
    "scope",
    "facilityStatus",
    "category",
    "maintenanceEngineer",
    "approvedBy",
    "maintenanceLogStatus",
    "componentsCategory",
    "projectType",
    'hideChart',
    "client_type",
    "client_group",
    "company_name",
    "facility",
    "contract_type",
    "billing_cycle",
    'client_id',
    'assignee_name',
    "bd_owner",
    "project_owner",
    'customer_status',
    'poFromDate',
    'poToDate',
    'poExpiryFromDate',
    'poExpiryToDate',
    'nextInvoiceFromDate',
    'nextInvoiceToDate',
    'salesperson',
    'client',
    'location',
    'stage',
    'projectOwner',
    'facility',
    'overdue_aging',
    'renewal_type',
  ];

  const existingParams = queryParams && Object.fromEntries([...queryParams]);
  const [filterOptions, setFilterOptions] = useState(existingParams);

  const [filterData, setFilterData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [dataFetched, setDataFetched] = useState(false);

  const [queryFilters, setQueryFilters] = useState(() => {
    const filteredParams = Object.keys(existingParams).reduce((acc, key) => {
      if (key !== "page" && key !== "tab" && key !== "search") {
        acc[key] = existingParams[key];
      }
      return acc;
    }, {});
    return filteredParams;
  });

  const filterDataOptions = useSelector((st) => ({
    projects: st.allProjects?.data?.allData?.map((item) => ({
      name: item.projname,
      id: item.pid
    })),
    locations: st.allLocations?.data?.data?.map((item) => ({
      id: item.id,
      name: item.name
    })),
    facilities: st.allFacilities?.data?.allData?.map((item) => ({
      name: item.facility_name,
      id: item.id
    })),
    meterTags: st.allMeterTags?.data?.meterTags?.map((item) => ({
      name: item.text,
      id: item.key
    })),
    meterStatus: st.allMeterStatus?.data?.meterStatus?.map((item) => ({
      name: item.name,
      id: item.id
    })),
    assignees: st.allAssignees?.data?.assignee?.map((item) => ({
      name: item.name,
      id: item.id
    })),
    calibrationAssignees: st.allGreenUsers?.data?.allData?.filter(item => item.status !== 'Inactive')?.map((item) => ({
      name: item.name,
      id: item.user_id
    })),
    status: st.allStatus?.data?.status?.map((item) => ({
      name: item.name,
      id: item.id
    })),
    ticketFacilities: st.allFacilitiesForTickets?.data?.allFacilities?.map((item) => ({
      name: item.facility_name,
      id: item.id
    })),
    scope: [
      {
        name: 'Desk',
        id: 'desk'
      },
      {
        name: 'Internal',
        id: 'internal'
      },
      {
        name: 'Announcement',
        id: 'announcement'
      },
      {
        name: 'Mobile',
        id: 'mobile'
      }
    ],
    facilityStatus: st.allFacilityStatus?.data?.status?.map((item) => ({
      name: item.name,
      id: item.id
    })),
    category: st.allClientAssetCategories?.data?.categories?.map((item) => ({
      name: item.name,
      id: item.id
    })),
    maintenanceEngineer: st.allMaintenanceEngineers?.data?.engineers?.map((item) => ({
      name: item.name,
      id: item.id
    })),
    approvedBy: st.allMaintenanceApprovers?.data?.approvers?.map((item) => ({
      name: item.name,
      id: item.id
    })),
    maintenanceLogStatus: st.allMaintenanceLogStatus?.data?.statuses?.map((item) => ({
      name: item.name,
      id: item.id
    })),
    componentsCategory: st.allComponentsCategories?.data?.categories?.map((item) => ({
      name: item.name,
      id: item.id
    })),
    projectType: PROJECT_TYPE_VALUES.map((item) => ({
      name: item,
      id: item
    })),
    clients: st.allClientsForFilter?.data?.allClients?.map(item => ({
      name: item.name,
      id: item.id
    })),
    hideChart: [
      { name: 'TRUE', id: 'true' },
      { name: 'FALSE', id: 'false' }
    ],
    bdClientTypes: (bdFilterOptions?.clientTypes || []).map(s => ({ name: s, id: s })),
    bdSegments: (bdFilterOptions?.segments || []).map(s => ({ name: s, id: s })),
    bdClientGroups: (bdFilterOptions?.clientGroups || []).map(s => ({ name: s, id: s })),
    bdCompanyNames: (bdFilterOptions?.companyNames || []).map(s => ({ name: s, id: s })),
    bdFacilities: (bdFilterOptions?.facilities || []).map(s => ({ name: s, id: s })),
    bdStatuses: (bdFilterOptions?.statuses || []).map(s => ({ name: s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()), id: s })),
    bdContractTypes: (bdFilterOptions?.contractTypes || []).map(s => ({ name: s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()), id: s })),
    bdBillingCycles: (bdFilterOptions?.billingCycles || []).map(s => ({ name: s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()), id: s })),
    bdOwners: (bdFilterOptions?.bdOwners || []).map(s => ({ name: s, id: s })),
    projectOwners: (bdFilterOptions?.projectOwners || []).map(s => ({ name: s, id: s })),
    bdCustomerStatuses: (bdFilterOptions?.customerStatuses || []).map(s => ({ name: s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()), id: s })),
    salespeople: (bdFilterOptions?.salespeople || []).map(s => ({ name: s, id: s })),
    bdClients: (bdFilterOptions?.clients || []).map(s => ({ name: s, id: s })),
    bdLocations: (bdFilterOptions?.locations || []).map(s => ({ name: s, id: s })),
    stages: (bdFilterOptions?.stages || []).map(s => ({ name: s, id: s })),
    pmLocations: (pmFilterOptions?.locations || []).map(s => ({ name: s, id: s })),
    pmFacilities: (pmFilterOptions?.facilities || []).map(s => ({ name: s, id: s })),
    pmProjectOwners: (pmFilterOptions?.projectOwners || []).map(s => ({ name: s, id: s })),
    bdOverdueAging: [
      { name: '0-45 Days', id: '0-45' },
      { name: '45-90 Days', id: '45-90' },
      { name: '90-180 Days', id: '90-180' },
      { name: '180+ Days', id: '180+' }
    ],
    renewalStatus: [
      { name: 'Due in 60 Days', id: 'due_60d' },
      { name: 'Approaching Expiry', id: 'approaching' },
      { name: 'Expired', id: 'expired' },
      { name: 'Completed', id: 'completed' }
    ],
  }));
  // useEffect(() => {

  // }, [filterDataOptions]);


  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterOptions((prevFilters) => {
      const updated = { ...prevFilters, [name]: value };
      if (name === 'client_id' && (filterArea === 'Inventory' || filterArea === 'EquipmentMeters')) {
        updated.facility_id = '';
        if (filterArea === 'EquipmentMeters') updated.project_id = '';
      }
      return updated;
    });
  };

  // Get the current filter value for autocomplete based on item type
  const getAutocompleteValue = (itemType) => {
    const typeToFilterMap = {
      'ticketFacilities': filterOptions?.facility_id,
      'calibrationAssignees': filterOptions?.assignee_name,
      'clients': filterOptions?.client_id,
      'bdClients': filterOptions?.client,
      'bdClientTypes': filterOptions?.client_type,
      'bdSegments': filterOptions?.segment,
      'bdClientGroups': filterOptions?.client_group,
      'bdCompanyNames': filterOptions?.company_name,
      'bdFacilities': filterOptions?.facility,
      'bdOwners': filterOptions?.bd_owner,
      'projectOwners': filterOptions?.project_owner,
      'salespeople': filterOptions?.salesperson,
      'locations': filterOptions?.location_id,
      'bdLocations': filterOptions?.location,
      'stages': filterOptions?.stage,
      'pmLocations': filterOptions?.location,
      'pmFacilities': filterOptions?.facility,
      'pmProjectOwners': filterOptions?.projectOwner,
      'projects': filterOptions?.project_id,
      'bdOverdueAging': filterOptions?.overdue_aging,
      'renewalStatus': filterOptions?.renewal_type,
    };
    return typeToFilterMap[itemType];
  };

  //Get the location name from location_id
  const getLocationName = (locationId) => {
    const location = filterDataOptions?.locations?.find(
      (loc) => loc.id === locationId
    );
    return location ? location.name : locationId;
  };

  //Get the Facility name from facility_id
  const getFacilityName = (facilityId) => {
    if (filterArea === 'Tickets' || filterArea === 'Inventory' || filterArea === 'VisitScheduled' || filterArea === 'EquipmentMeters') {
      const facility = filterDataOptions?.ticketFacilities?.find(
        (fac) => String(fac.id) === String(facilityId)
      );
      return facility ? facility.name : facilityId;
    } else {
      const facility = filterDataOptions?.facilities?.find(
        (fac) => fac.id === facilityId
      );
      return facility ? facility.name : facilityId;
    }
  };

  //Get the Project name from pid
  const getProjectName = (projectId) => {
    const project = filterDataOptions?.projects?.find(
      (proj) => String(proj.id) === String(projectId)
    );
    return project ? `${project.name} (PID:${project.id})` : projectId;
  };

  //Get the Tag name from meterTags
  const getTagName = (tagId) => {
    const tag = filterDataOptions?.meterTags?.find((tag) => tag.id === tagId);
    return tag ? tag.name : tagId;
  };

  //Get the ParameterGroup name from meterGrp
  const paraMeterGroupName = (meterGroup) => {
    const group = parameterGrpOption?.find(
      (meterGrp) => meterGrp.value === meterGroup
    );
    return group ? group.label : meterGroup;
  };

  const convertHideChartLabel = (hideChartvalue) => {
    return `Hide-Chart: ${hideChartvalue.toUpperCase()}`;
  }

  //Get the Client name from client_id
  const getClientName = (clientId) => {
    const client = filterDataOptions?.clients?.find(
      (cl) => cl.id === clientId
    );
    return client ? client.name : clientId;
  };

  const convertScopeLabel = (scopeValue) => {
    return scopeValue?.toUpperCase();
  }

  //Converting the filter keys to actual values
  const transformFilters = (overrideOptions = null) => {
    const sourceOptions = overrideOptions || filterOptions;
    if (!sourceOptions) {
      return;
    }
    const fltrOptions = {};
    for (const [key, value] of Object.entries(sourceOptions)) {
      if (value) {
        fltrOptions[key] = value;
      }
    }

    if (Object.keys(fltrOptions).length > 0 && filterArea !== 'VisitScheduled' && filterArea !== 'Opportunity' && filterArea !== 'ProjectManagement' && filterArea !== 'Renewal') {
      fltrOptions.page = 1;
    }

    const filters = Object.entries(fltrOptions)
      .filter(([key, value]) => allFilters.includes(key) && value)
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});

    if (filters.location_id) {
      filters.location_id = getLocationName(filters.location_id);
    }
    if (filters.facility_id) {
      filters.facility_id = getFacilityName(filters.facility_id);
    }
    if (filters.project_id) {
      filters.project_id = getProjectName(filters.project_id);
    }
    if (filters.meterTags) {
      filters.meterTags = getTagName(filters.meterTags);
    }
    if (filters.meterGrp) {
      filters.meterGrp = paraMeterGroupName(filters.meterGrp);
    }
    if (filters.hideChart) {
      filters.hideChart = convertHideChartLabel(filters.hideChart);
    }
    if (filters.scope) {
      filters.scope = convertScopeLabel(filters.scope);
    }
    if (filters.client_id) {
      filters.client_id = getClientName(filters.client_id);
    }

    if (filters.poFromDate || filters.poToDate) {
      const from = filters.poFromDate;
      const to = filters.poToDate;
      if (from && to) {
        filters.poDateRange = `PO Date: ${from} to ${to}`;
      } else if (from) {
        filters.poDateRange = `PO Date: From ${from}`;
      } else {
        filters.poDateRange = `PO Date: To ${to}`;
      }
      delete filters.poFromDate;
      delete filters.poToDate;
    }

    if (filters.poExpiryFromDate || filters.poExpiryToDate) {
      const from = filters.poExpiryFromDate;
      const to = filters.poExpiryToDate;
      if (from && to) {
        filters.poExpiryDateRange = `PO Expiry Date: ${from} to ${to}`;
      } else if (from) {
        filters.poExpiryDateRange = `PO Expiry Date: From ${from}`;
      } else {
        filters.poExpiryDateRange = `PO Expiry Date: To ${to}`;
      }
      delete filters.poExpiryFromDate;
      delete filters.poExpiryToDate;
    }

    if (filters.nextInvoiceFromDate || filters.nextInvoiceToDate) {
      const from = filters.nextInvoiceFromDate;
      const to = filters.nextInvoiceToDate;
      if (from && to) {
        filters.nextInvoiceDateRange = `Next Invoice Date: ${from} to ${to}`;
      } else if (from) {
        filters.nextInvoiceDateRange = `Next Invoice Date: From ${from}`;
      } else {
        filters.nextInvoiceDateRange = `Next Invoice Date: To ${to}`;
      }
      delete filters.nextInvoiceFromDate;
      delete filters.nextInvoiceToDate;
    }

    setAppliedFilters(filters);

    if (!filterArea === "Facility" || !filterArea === "Reports") {
      setIsSearchOrFilterApplied(true);
    }
  };

  const handleFilterApply = () => {

    if (filterArea === "Tickets" || filterArea === 'Client Assets' || filterArea === 'Inventory' || filterArea === 'BusinessDashboard') {
      handleTabSwitch();
    }

    transformFilters();

    const fltrOptions = {};
    for (const [key, value] of Object.entries(filterOptions)) {
      if (value) {
        fltrOptions[key] = value;
      }
    }

    if (Object.keys(fltrOptions).length > 0 && filterArea !== 'VisitScheduled' && filterArea !== 'Opportunity' && filterArea !== 'ProjectManagement' && filterArea !== 'Renewal') {
      fltrOptions.page = 1;
    }

    updateQueryParams(fltrOptions);

    setShowFilterDialog(false);
  };

  const clearAllFilter = () => {
    const fOption = { ...filterOptions };

    const hasActiveFilters = Object.entries(fOption).some(
      ([key, value]) => value && key !== 'page' && key !== 'search' && key !== 'tab'
    );

    if (fOption.hasOwnProperty("search")) {
      delete fOption.search;
    }
    if (fOption.hasOwnProperty("tab")) {
      delete fOption.tab;
    }
    Object.keys(fOption).forEach((key) => {
      fOption[key] = "";
    });

    if (hasActiveFilters) {
      updateQueryParams(fOption);
    }
    setFilterOptions(fOption);
    setShowFilterDialog(false);
    setAppliedFilters("");
  };

  const clearChipFilter = (filterKey) => {
    const updatedFilterOptions = { ...filterOptions };

    if (updatedFilterOptions.hasOwnProperty("search")) {
      delete updatedFilterOptions.search;
    }
    if (updatedFilterOptions[filterKey]) {
      updatedFilterOptions[filterKey] = "";
    }

    if (filterKey === 'client_id' && (filterArea === 'Inventory' || filterArea === 'EquipmentMeters')) {
      updatedFilterOptions.facility_id = '';
      if (filterArea === 'EquipmentMeters') updatedFilterOptions.project_id = '';
    }

    if (filterKey === 'poDateRange') {
      updatedFilterOptions.poFromDate = "";
      updatedFilterOptions.poToDate = "";
    }
    
    if (filterKey === 'poExpiryDateRange') {
      updatedFilterOptions.poExpiryFromDate = "";
      updatedFilterOptions.poExpiryToDate = "";
    }
    
    if (filterKey === 'nextInvoiceDateRange') {
      updatedFilterOptions.nextInvoiceFromDate = "";
      updatedFilterOptions.nextInvoiceToDate = "";
    }

    setFilterOptions(updatedFilterOptions);
    if (appliedFilters[filterKey]) {
      appliedFilters[filterKey] = null;
    }
    setAppliedFilters(appliedFilters);
    updateQueryParams(updatedFilterOptions);

    // Update the applied filters
    // transformFilters();
  };

  useEffect(() => {
    if (filterData?.length === 0) return;

    // Skip API calls for areas that get filter options from dashboard API
    if (filterArea === "Opportunity" || filterArea === "ProjectManagement") {
      setDataFetched(true);
      return;
    }

    const fetchedTypes = [];
    const dispatchPromises = [];

    const dispatchMap = {
      locations: () => dispatch(getClientLocations(client_id)),
      facilities: () => dispatch(getAllFacilities(client_id)),
      ticketFacilities: () => dispatch(getAllFacilitiesForTickets(
        (filterArea === 'Inventory' || filterArea === 'EquipmentMeters') ? (filterOptions?.client_id || undefined) : client_id
      )),
      projects: () => filterArea === 'EquipmentMeters'
        ? (filterOptions?.client_id ? dispatch(getAllProject(filterOptions.client_id)) : Promise.resolve())
        : dispatch(getAllProject(client_id)),
      meterTags: () => dispatch(getAllMeterTags()),
      meterStatus: () => dispatch(getAllMeterStatus()),
      assignees: () => dispatch(getAllAssignees()),
      calibrationAssignees: () => dispatch(getJoinedGreenUsers()),
      status: () => dispatch(getAllTicketStatus()),
      facilityStatus: () => dispatch(getAllFacilityStatus()),
      category: () => dispatch(getAllClientAssetCategories()),
      maintenanceEngineer: () => dispatch(getAllMaintenanceEngineers()),
      approvedBy: () => dispatch(getAllMaintenanceApprovers()),
      maintenanceLogStatus: () => dispatch(getAllMaintenanceLogStatus()),
      componentsCategory: () => dispatch(getAllComponentsCategories()),
      clients: () => dispatch(getAllClientsForFilter())
    };

    filterData.forEach(item => {
      const dispatchAction = dispatchMap[item.type];
      if (dispatchAction) {
        dispatchPromises.push(
          dispatchAction().then(() => {
            fetchedTypes.push(item.type);
          })
        );
      }
    });

    Promise.all(dispatchPromises).then(() => {
      const filteredDataWithApiTypes = filterData.filter(item => (item.type !== "hideChart" && item.type !== "scope" && item.type !== "projectType" && !item.type.startsWith("bd")));
      const allTypesFetched = filteredDataWithApiTypes.every(item => fetchedTypes.includes(item.type));
      if (allTypesFetched) {
        setDataFetched(true);
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);


  useEffect(() => {
    if ((filterDataOptions && dataFetched) || (filterArea === "Reports") || (filterArea === "BusinessDashboard") || (filterArea === "Renewal") || (filterArea === "Opportunity") || (filterArea === "ProjectManagement")) {
      transformFilters()
    }
  }, [queryFilters, dataFetched, bdFilterOptions, pmFilterOptions])

  useEffect(() => {
    if (clearFilters) {
      setAppliedFilters("");
    }
  }, [clearFilters]);

  const isFirstClientChange = React.useRef(true);
  useEffect(() => {
    if (filterArea !== 'Inventory' && filterArea !== 'EquipmentMeters') return;
    if (isFirstClientChange.current) {
      isFirstClientChange.current = false;
      return;
    }
    dispatch(getAllFacilitiesForTickets(filterOptions?.client_id || undefined));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOptions?.client_id]);

  const isFirstEquipmentMetersProjectLoad = React.useRef(true);
  useEffect(() => {
    if (filterArea !== 'EquipmentMeters') return;
    if (isFirstEquipmentMetersProjectLoad.current) {
      isFirstEquipmentMetersProjectLoad.current = false;
      return;
    }
    if (filterOptions?.client_id) {
      dispatch(getAllProject(filterOptions.client_id));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOptions?.client_id]);

  useEffect(() => {
    const fData = [];
    if (
      filterArea === "Facilities" ||
      filterArea == "Projects" ||
      filterArea == "Meters"
    ) {
      fData.push({
        type: "locations",
        label: "Location",
        name: "location_id",
        data: [],
      });

      // fetchClientLocations()
    }
    if (filterArea === "Projects" || filterArea == "Meters" || filterArea === "Reports" || filterArea == "Client Assets") {
      fData.push({
        type: "facilities",
        label: "Facility",
        name: "facility_id",
        data: [],
      });
    }
    if (filterArea === "Maintenance Logs") {
      fData.push({
        type: "maintenanceEngineer",
        label: "Engineer",
        name: "maintenanceEngineer",
        data: [],
      });
      fData.push({
        type: "approvedBy",
        label: "Approved By",
        name: "approvedBy",
        data: [],
      });
      fData.push({
        type: "maintenanceLogStatus",
        label: "Maintenance Status",
        name: "maintenanceLogStatus",
        data: [],
      });
    }

    if (filterArea === 'Projects') {
      fData.push({
        type: "projectType",
        label: "Project Type",
        name: "projectType",
        data: [],
      })
    }

    if (filterArea === 'Inventory') {
      fData.push({
        type: "clients",
        label: "Client",
        name: "client_id",
        data: [],
      });
      fData.push({
        type: "ticketFacilities",
        label: "Facility",
        name: "facility_id",
        data: [],
      });
    }
    if (filterArea === "components") {
      fData.push({
        type: "componentsCategory",
        label: "Category",
        name: "componentsCategory",
        data: [],
      });
    }
    if (filterArea === "Meters") {
      fData.push({
        type: "projects",
        label: "Projects",
        name: "project_id",
        data: [],
      });

      fData.push({
        type: "meterTags",
        label: "Meter Tags",
        name: "meterTags",
        data: [],
      });

      fData.push({
        type: "meterStatus",
        label: "Meter Status",
        name: "meterStatus",
        data: [],
      });

      fData.push({
        type: "hideChart",
        label: "Hide Chart",
        name: "hideChart",
        data: [],
      });
    }
    if (filterArea === "Facilities") {
      fData.push({
        type: "facilityStatus",
        label: "Status",
        name: "facilityStatus",
        data: [],
      });
    }
    if (filterArea == "Tickets") {
      if (!checkForMyTickets) {
        fData.push({
          type: "assignees",
          label: "Assignee",
          name: "assignee",
          data: [],
        });
      }

      fData.push({
        type: "status",
        label: "Status",
        name: "status",
        data: [],
      });



      if (!checkForUrlFacility) {
        fData.push({
          type: "ticketFacilities",
          label: "Facility",
          name: "facility_id",
          data: [],
        });
        fData.push({
          type: "scope",
          label: "Scope",
          name: "scope",
          data: [],
        });
      }
    }
    if (filterArea === "BusinessDashboard") {
      fData.push({
        type: "bdClientTypes",
        label: "Client Type",
        name: "client_type",
        data: [],
      });
      fData.push({
        type: "bdSegments",
        label: "Segment",
        name: "segment",
        data: [],
      });
      fData.push({
        type: "bdClientGroups",
        label: "Client Group",
        name: "client_group",
        data: [],
      });
      fData.push({
        type: "bdCompanyNames",
        label: "Company Name",
        name: "company_name",
        data: [],
      });
      fData.push({
        type: "bdFacilities",
        label: "Facility",
        name: "facility",
        data: [],
      });
      fData.push({
        type: "bdOwners",
        label: "BD Owner",
        name: "bd_owner",
        data: [],
      });
      fData.push({
        type: "projectOwners",
        label: "Project Owner",
        name: "project_owner",
        data: [],
      });
      fData.push({
        type: "bdStatuses",
        label: "Status",
        name: "status",
        data: [],
      });
      fData.push({
        type: "bdContractTypes",
        label: "Contract Type",
        name: "contract_type",
        data: [],
      });
      fData.push({
        type: "bdBillingCycles",
        label: "Billing Cycle",
        name: "billing_cycle",
        data: [],
      });
      fData.push({
        type: "bdCustomerStatuses",
        label: "Customer Status",
        name: "customer_status",
        data: [],
      });
      fData.push({
        type: "bdOverdueAging",
        label: "Overdue - Aging (Days)",
        name: "overdue_aging",
        data: [],
      });
    }
    if (filterArea === "Opportunity") {
      fData.push({
        type: "bdClients",
        label: "Client / Project",
        name: "client",
        data: [],
      });
      fData.push({
        type: "bdLocations",
        label: "Location",
        name: "location",
        data: [],
      });
      fData.push({
        type: "salespeople",
        label: "Salesperson",
        name: "salesperson",
        data: [],
      });
      fData.push({
        type: "stages",
        label: "Stage",
        name: "stage",
        data: [],
      });
    }
    if (filterArea === "ProjectManagement") {
      fData.push({
        type: "pmLocations",
        label: "Location",
        name: "location",
        data: [],
      });
      fData.push({
        type: "pmFacilities",
        label: "Facility",
        name: "facility",
        data: [],
      });
      fData.push({
        type: "pmProjectOwners",
        label: "Project Owner",
        name: "projectOwner",
        data: [],
      });
    }
    if (filterArea === "Renewal") {
      fData.push({
        type: "renewalStatus",
        label: "Renewal Status",
        name: "renewal_type",
        data: [
          { name: 'All Renewals', id: '' },
          { name: 'Due in 60 Days', id: 'due_60d' },
          { name: 'Approaching Expiry', id: 'approaching' },
          { name: 'Expired', id: 'expired' },
          { name: 'Completed', id: 'completed' }
        ],
      });
      fData.push({
        type: "bdClientGroups",
        label: "Client",
        name: "client_group",
        data: [],
      });
    }
    if (filterArea === "VisitScheduled") {
      fData.push({
        type: "calibrationAssignees",
        label: "Assignee",
        name: "assignee_name",
        data: [],
      });
      fData.push({
        type: "ticketFacilities",
        label: "Facility",
        name: "facility_id",
        data: [],
      });
    }

    if (filterArea === "EquipmentMeters") {
      fData.push({ type: "clients", label: "Client", name: "client_id", data: [] });
      fData.push({ type: "ticketFacilities", label: "Facility", name: "facility_id", data: [] });
      fData.push({ type: "projects", label: "Project", name: "project_id", data: [] });
      fData.push({ type: "meterStatus", label: "Status", name: "meterStatus", data: [] });
    }

    setFilterData(fData);
  }, [checkForMyTickets, filterArea]);

  useEffect(() => {
    if ((filterArea === "Tickets" || filterArea === 'Client Assets' || filterArea === 'Inventory' || filterArea === 'BusinessDashboard') && isBrowserBackAction) {
      handleFilterApply()
    }
  }, [filterOptions])

  useEffect(() => {
    if (queryParams) {
      const filterOptionsFromParams = Object.fromEntries([...queryParams]);
      
      // Check if NEW params are empty (not old state)
      if (Object.keys(filterOptionsFromParams).length <= 0) {
        clearAllFilter();
        return;
      }
      
      setFilterOptions(filterOptionsFromParams);
      const filteredParams = Object.keys(filterOptionsFromParams).reduce((acc, key) => {
        if (key !== 'page' && key !== 'tab' && key !== 'search') {
          acc[key] = filterOptionsFromParams[key];
        }
        return acc;
      }, {});
      setQueryFilters(filteredParams);
      transformFilters(filterOptionsFromParams);
    }
  }, [queryParams]);

  //   useEffect(() => {
  //     if (
  //       queryParams &&
  //       (clientFacilityData.length > 0 ||
  //         locationData.length > 0 ||
  //         projectData.length > 0 ||
  //         meterTags.length > 0)
  //     ) {
  //       const filterOptionsFromParams = Object.fromEntries([...queryParams]);
  //       setFilterOptions(filterOptionsFromParams);
  //       handleFilterApply();
  //     }
  //   }, [clientFacilityData, locationData, projectData, meterTags]);



  // useEffect(() => {
  //   if(queryParams.get('meterGrp')){
  //     handleFilterApply();
  //   }
  // },[parameterGrpOption?.length > 0])


  return (
    <div>
      <div>
        {appliedFilters && Object.values(appliedFilters).some(value => value !== null) && (
          <Grid
            container
            spacing={1}
            alignItems="center"
            direction="row"
            paddingBottom="8px"
          >
            <Grid container item md={12}>
              <Typography
                variant="subtitle2"
                style={{ fontWeight: 600, fontSize: "14px" }}
              >
                Filters:
              </Typography>
            </Grid>
            <Grid container item md={12}>
              {Object.entries(appliedFilters).map(([key, value], index) => {
                if (!value) {
                  return null;
                }
                return (
                  <Chip
                    key={index}
                    size="small"
                    label={`${value}`.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                    onDelete={() => clearChipFilter(key)}
                    variant="contained"
                    sx={{
                      margin: '2px 4px',
                      padding: '4px 2px',
                      backgroundColor: 'white',
                      color: '#008080',
                      fontWeight: 500,
                      fontSize: '12px',
                      borderRadius: '16px',
                      border: '1px solid #008080',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 128, 128, 0.08)',
                      },
                      '& .MuiChip-deleteIcon': {
                        color: '#008080',
                        fontSize: '16px',
                        '&:hover': {
                          color: '#006666'
                        }
                      }
                    }}
                  />
                )
              })}
            </Grid>
          </Grid>
        )}
      </div>
      <Drawer
        anchor="right"
        open={showFilterDialog}
        onClose={() => setShowFilterDialog(false)}
        PaperProps={{
          style: {
            width: 300,
          },
        }}
      >
        <Box p={2} style={{ padding: "0px" }}>
          <DialogTitle style={{ padding: "20px 16px" }}>
            <Tooltip title="Go Back">
              <IconButton
                style={{ paddingLeft: 0 }}
                onClick={() => setShowFilterDialog(false)}
                color="inherit">
                <ArrowBackIcon fontSize='small' />
              </IconButton>
            </Tooltip>
            Filter {filterArea}
          </DialogTitle>
          <DialogContent style={{ paddingLeft: "16px", paddingRight: "16px" }}>
            {filterData.map((item) => {
              return (
                <>
                  <InputLabel htmlFor={item.type} style={{ marginTop: "15px" }}>
                    {item.label}
                  </InputLabel>
                  {(item.type === 'ticketFacilities' || item.type === 'projects' || item.type === 'clients' || item.type === 'bdClients' || item.type === 'bdClientTypes' || item.type === 'bdSegments' || item.type === 'bdClientGroups' || item.type === 'bdCompanyNames' || item.type === 'bdFacilities' || item.type === 'bdOwners' || item.type === 'projectOwners' || item.type === 'assignees' || item.type === 'calibrationAssignees' || item.type === 'salespeople' || item.type === 'locations' || item.type === 'bdLocations' || item.type === 'stages' || item.type === 'pmLocations' || item.type === 'pmFacilities' || item.type === 'pmProjectOwners' || item.type === 'bdOverdueAging') ? (
                    <Autocomplete
                      options={filterDataOptions[item.type] || []}
                      value={filterDataOptions[item.type]?.find(option =>
                        (item.type === 'assignees' || item.type === 'calibrationAssignees')
                          ? option.name == filterOptions?.[item.name]
                          : option.id == getAutocompleteValue(item.type)
                      ) || null}
                      onChange={(event, newValue) => {
                        handleFilterChange({ target: { name: item?.name, value: item.type === 'assignees' ? newValue?.name : newValue?.id } });
                      }}
                      renderInput={(params) => <TextField {...params} fullWidth sx={{
                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#008080',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: '#008080',
                        },
                      }} />}
                      getOptionLabel={(option) => (item.type === 'ticketFacilities') ? `${option.name} (${option.id})` : (item.type === 'clients' || item.type === 'bdClients' || item.type === 'bdClientTypes' || item.type === 'bdSegments' || item.type === 'bdClientGroups' || item.type === 'bdCompanyNames' || item.type === 'bdFacilities' || item.type === 'bdOwners' || item.type === 'projectOwners' || item.type === 'assignees' || item.type === 'calibrationAssignees' || item.type === 'salespeople' || item.type === 'locations' || item.type === 'bdLocations' || item.type === 'stages' || item.type === 'pmLocations' || item.type === 'pmFacilities' || item.type === 'pmProjectOwners' || item.type === 'bdOverdueAging') ? `${option.name}` : `${option.name} (PID:${option.id})`}
                      disableClearable
                    />
                  ) : (
                    <Select
                      name={item.name}
                      value={filterOptions[item.name]}
                      onChange={handleFilterChange}
                      fullWidth
                      sx={selectFocusedStyle}
                    >
                      {filterDataOptions[item.type]?.map((fItem) => (
                        <MenuItem key={`${fItem.type}-${fItem.id}`} value={fItem.id}>
                          {fItem.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                </>
              );
            })}

            {(segmentDataOption?.length > 0 || filterArea === "Facilities") && (
              <>
                <InputLabel htmlFor="segment" style={{ marginTop: "15px" }} sx={inputLabelFocusedStyle}>
                  Segment
                </InputLabel>
                <Select
                  name="segment"
                  value={filterOptions?.segment}
                  onChange={handleFilterChange}
                  fullWidth
                  sx={selectFocusedStyle}
                >
                  {segmentDataOption?.map((item, idx) => (
                    <MenuItem key={`seg-${idx}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}

            {(reportTypesOption?.length > 0 || filterArea === "Reports") && (
              <>
                <InputLabel htmlFor="type" style={{ marginTop: "15px" }} sx={inputLabelFocusedStyle}>
                  Type
                </InputLabel>
                <Select
                  name="type"
                  value={filterOptions?.type}
                  onChange={handleFilterChange}
                  fullWidth
                  sx={selectFocusedStyle}
                >
                  {reportTypesOption?.map((item, idx) => (
                    <MenuItem key={`sec-report-${idx}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}

            {(sectionListOption?.length > 0 || filterArea === "Reports") && (
              <>
                <InputLabel htmlFor="section" style={{ marginTop: "15px" }} sx={inputLabelFocusedStyle}>
                  Section
                </InputLabel>
                <Select
                  name="section"
                  value={filterOptions?.section}
                  onChange={handleFilterChange}
                  fullWidth
                  sx={selectFocusedStyle}
                >
                  {sectionListOption?.map((item, idx) => (
                    <MenuItem key={`section-${idx}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}

            {(plantTypeOption?.length > 0 || filterArea === "Projects") && (
              <>
                <InputLabel htmlFor="plantType" style={{ marginTop: "15px" }} sx={inputLabelFocusedStyle}>
                  Plant Type
                </InputLabel>
                <Select
                  name="plantType"
                  value={filterOptions?.plantType}
                  onChange={handleFilterChange}
                  fullWidth
                  sx={selectFocusedStyle}
                >
                  {plantTypeOption?.map((item, idx) => (
                    <MenuItem key={`seg-plant-type-${idx}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}

            {(capacityOption?.length > 0 || filterArea === "Projects") && (
              <>
                <InputLabel htmlFor="capacity" style={{ marginTop: "15px" }} sx={inputLabelFocusedStyle}>
                  Capacity
                </InputLabel>
                <Select
                  name="capacity"
                  value={filterOptions?.capacity}
                  onChange={handleFilterChange}
                  fullWidth
                  sx={selectFocusedStyle}
                >
                  {capacityOption?.map((item, idx) => (
                    <MenuItem key={`seg-capacity-${idx}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}

            {(parameterGrpOption?.length > 0 || filterArea === "Meters") && (
              <>
                <InputLabel htmlFor="meterGrp" style={{ marginTop: "15px" }} sx={inputLabelFocusedStyle}>
                  Parameter Group
                </InputLabel>
                <Select
                  name="meterGrp"
                  value={filterOptions?.meterGrp}
                  onChange={handleFilterChange}
                  fullWidth
                  sx={selectFocusedStyle}
                >
                  {parameterGrpOption?.map((item, idx) => (
                    <MenuItem
                      key={`seg-paramert-grp-${idx}`}
                      value={item?.value}
                    >
                      {item?.label}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}

            {(alertOption?.length > 0 || filterArea === "Meters") && (
              <>
                <InputLabel htmlFor="alert" style={{ marginTop: "15px" }} sx={inputLabelFocusedStyle}>
                  Alert Priority
                </InputLabel>
                <Select
                  name="alert"
                  value={filterOptions?.alert}
                  onChange={handleFilterChange}
                  fullWidth
                  sx={selectFocusedStyle}
                >
                  {alertOption?.map((item, idx) => (
                    <MenuItem key={`seg-alert-${idx}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}

            {(regionsOption?.length > 0 || filterArea === "Clients") && (
              <>
                <InputLabel htmlFor="region" sx={inputLabelFocusedStyle}>Region</InputLabel>
                <Select
                  name="region"
                  value={filterOptions?.region}
                  onChange={handleFilterChange}
                  fullWidth
                  sx={selectFocusedStyle}
                >
                  {regionsOption?.map((region) => (
                    <MenuItem key={`region_${region}`} value={region}>
                      {region}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}

            {/* {(assigneeOptions?.length > 0 || filterArea === "Tickets") && (
              <>
                <InputLabel htmlFor="capacity" style={{ marginTop: "15px" }}>
                  Assignee
                </InputLabel>
                <Select
                  name="assignee"
                  value={filterOptions?.assignee}
                  onChange={handleFilterChange}
                  fullWidth
                >
                  {assigneeOptions?.map((item, idx) => (
                    <MenuItem key={`seg-assignee-${idx}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )} */}
          </DialogContent>
          <Grid container item md={12} direction="column" paddingX={1}>
            <DialogActions>
              <Grid item container md={6} justifyContent="center">
                <Button style={{ borderColor: '#008080', color: '#008080' }} onClick={clearAllFilter} variant="outlined">
                  Clear Filter
                </Button>
              </Grid>
              <Grid item container md={6} justifyContent="center">
                <Button style={{ backgroundColor: '#008080', color: 'white' }} onClick={handleFilterApply} variant="contained">
                  Apply Filter
                </Button>
              </Grid>
            </DialogActions>
          </Grid>
        </Box>
      </Drawer>
    </div>
  );
};

export default Filter;
